import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modal", "form"]

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener('keydown', this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleKeydown)
  }

  open(event) {
    const candidateId = event.currentTarget.dataset.candidateId
    
    if (!candidateId) {
      console.error('Candidate ID not found!')
      return
    }
    
    this.formTarget.reset()
    
    const submitButton = this.formTarget.querySelector('input[type="submit"]')
    if (submitButton) {
      submitButton.disabled = false
    }
    
    const inputs = this.formTarget.querySelectorAll('input:not([type="submit"])')
    inputs.forEach(input => {
      input.disabled = false
      input.value = ''
    })
    
    this.formTarget.action = `/annuaire/${candidateId}/diplome.pdf`
    
    this.modalTarget.style.display = "flex"
  }

  close() {
    this.modalTarget.style.display = "none"
    
    setTimeout(() => {
      this.cleanForm()
    }, 100)
  }

  cleanForm() {
    this.formTarget.reset()
    
    this.formTarget.action = "#"
    
    const submitButton = this.formTarget.querySelector('input[type="submit"]')
    if (submitButton) {
      submitButton.disabled = false
    }
    
    const inputs = this.formTarget.querySelectorAll('input:not([type="submit"])')
    inputs.forEach(input => {
      input.disabled = false
      input.value = ''
    })
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.modalTarget.style.display === 'flex') {
      this.close()
    }
  }
}
